import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EftPaymentService {

  constructor(private http: HttpClient) { }

  eftPaymentData(eftData: any):Observable<any>{
    return this.http.post(environment.monerisUrl + '/processEFTPayment', eftData);
  }
}
